import { ACTIONS } from '../actions';

const INITIAL_STATE = {
    ip_block: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.GET_IP_BLOCK:
        if(!action.payload.data || !action.payload.data.ip_block) {
            return { ...state, ip_block: [] };
        }
        return { ...state, ip_block: action.payload.data.ip_block.split(";") };
        default:
            return state;
    }
}
